export default __webpack_public_path__ + "static/media/image38.3553f015.png";